import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4c50b455&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=4c50b455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50b455",
  null
  
)

export default component.exports